import { PieChart, RingChart, BarChart } from './AnalysisCharts';
import UIFetchService from '../Service/UIFetchService';
import { toThousands } from '../Service/Utils'

import { Link } from 'react-router-dom';
import { SwapOutlined } from '@ant-design/icons';
import { Row, Col, Progress, Divider, Skeleton, Popover, Card } from 'antd';
import React from 'react';

class UserClusteringAnalysisComparator extends React.Component {
    constructor() {
        super();
        this.state = {
            rightSummary: {},
            rightCharts: [],
            leftCharts: []
        };
    }

    async componentDidMount() {
        const rightSummary = await UIFetchService.get(`/api/v1/user_clustering/clusters/${this.props.rightId}/summary`);
        if (rightSummary) {
            rightSummary.id = this.props.clusteringId;
        }
        const tags = await UIFetchService.get('/api/v1/metadata/tags/tree?filter=analysis');
        const tagsOptions = tags.map(category => {
            return {
                label: category.title,
                value: category.key,
                children: category.children.map(tag => {
                    return {
                        label: tag.title,
                        value: tag.key
                    };
                })
            };
        });
        const leftCharts = await this.fetchLeftCharts();
        const rightCharts = leftCharts.map(left => {
            const chart = Object.assign({}, left);
            chart.loading = true;
            chart.result = null;
            return chart;
        });
        this.fetchRightCharts(rightCharts);
        this.setState({ leftCharts, rightSummary, rightCharts, tagsOptions });
    }

    render() {
        return <>
            <Row>
                <Col>
                    <Link to={`/analysis`}>{"<返回分析页面"}</Link>
                </Col>
            </Row>
            <Row>
                <Col span={12} style={{ textAlign: 'left' }}>
                    <h2>{this.props.leftSummary.name}</h2>
                </Col>
                <Col span={12} style={{ textAlign: 'left' }}>
                    <h2>{this.state.rightSummary.name}</h2>
                </Col>
            </Row>
            <Row>
                <Col span={12} style={{ alignSelf: 'center', textAlign: 'left' }}>
                    <span>最新更新时间：{this.props.leftSummary.latestDate}</span>
                </Col>
                <Col span={12} style={{ alignSelf: 'center', textAlign: 'left' }}>
                    <span>最新更新时间：{this.state.rightSummary.latestDate}</span>
                </Col>
            </Row>
            <div style={{ height: '40px' }} />
            <Row>
                <Col span={12} style={{ textAlign: 'left' }}>
                    <h3>目标用户群</h3>
                </Col>
                <Col span={12} style={{ textAlign: 'left' }}>
                    <h3>对比用户群</h3>
                </Col>
            </Row>
            <Row>
                <Col flex="70px">
                    <Progress type="circle" percent={this.getClusterPercent(this.props.leftSummary)} width={70} />
                </Col>
                <Col flex="300px">
                    <Row>
                        <Col flex="10px" />
                        <Col flex="200px" style={{ textAlign: 'left' }}>
                            <span style={{ fontSize: 27 }}>
                                {toThousands(this.props.leftSummary.todayResult)}
                            </span>
                            <span>人</span>
                        </Col>
                    </Row>
                    <Row>
                        <Col flex="10px" />
                        <Col flex="100%" style={{ textAlign: 'left' }}>
                            <span style={{ color: 'gray', padding: '0px 14px' }} >
                                在全部用户{toThousands(this.props.leftSummary.todayTotal)}人中占比{this.getClusterPercent(this.props.leftSummary)}%
                            </span>
                        </Col>
                    </Row>
                </Col>
                <Col flex="auto" />
                <Col flex="70px">
                    <Progress type="circle" percent={this.getClusterPercent(this.state.rightSummary)} width={70} />
                </Col>
                <Col flex="300px">
                    <Row>
                        <Col flex="10px" />
                        <Col flex="200px" style={{ textAlign: 'left' }}>
                            <span style={{ fontSize: 27 }}>
                                {toThousands(this.state.rightSummary.todayResult)}
                            </span>
                            <span>人</span>
                        </Col>
                    </Row>
                    <Row>
                        <Col flex="10px" />
                        <Col flex="100%" style={{ textAlign: 'left' }}>
                            <span style={{ color: 'gray', padding: '0px 14px' }} >
                                在全部用户{toThousands(this.state.rightSummary.todayTotal)}人中占比{this.getClusterPercent(this.state.rightSummary)}%
                            </span>
                        </Col>
                    </Row>
                </Col>
                <Col flex="auto" />
            </Row>
            <Divider />
            <Row>
                <Col span={12}>
                    {this.state.leftCharts.map((chart, index) =>
                        <Row>
                            <Col flex="100%" >
                                {this.renderCard(chart, index, this.state.rightCharts)}
                            </Col>
                        </Row>)}
                </Col>
                <Col span={12}>
                    {this.state.rightCharts.map((chart, index) =>
                        <Row>
                            <Col flex="100%" >
                                {this.renderCard(chart, index, this.state.leftCharts)}
                            </Col>
                        </Row>)}
                </Col>
            </Row>
        </>
    }

    renderCard(chart, index, others) {
        return <Card size="small" style={{ margin: '0px 5px 10px' }} >
            <Row justify="space-between" key={index} >
                <Col style={{ padding: '0px 0px' }}>
                    <span style={{ fontSize: 15 }} >{this.getTagFullName(chart.tagId)}</span>
                </Col>
                {others[index] !== undefined && !others[index].loading &&
                    <Col style={{ padding: '0px 0px' }}>
                        <Popover content={this.makeDiff(chart, others[index])} title="详细对比" >
                            <SwapOutlined />
                        </Popover>
                    </Col>}
            </Row>
            {!chart.loading &&
                <Row>
                    <Col>
                        <span style={{ fontSize: 11, color: 'gray' }} >拥有标签的{toThousands(chart.result?.total)}人占总人数的{chart.result?.totalPercent.toFixed(2)}%</span>
                    </Col>
                </Row>
            }
            <Row>
                <Col flex="100%">
                    {this.renderChart(chart)}
                </Col>
            </Row>
        </Card>
    }

    renderChart(chart) {
        if (chart.loading || !chart.result) {
            return <Skeleton active />;
        }

        switch (chart.chartType) {
            case 'CHART_BAR':
                return <BarChart dataSource={chart} />
            case 'CHART_RING':
                return <RingChart dataSource={chart} />
            case 'CHART_PIE':
                return <PieChart dataSource={chart} />
            default:
                return <></>
        }
    }

    makeDiff(left, right) {
        if (right === undefined || !right.result || !left.result) {
            return <span>数据未准备好</span>
        }
        //console.log(left, right);
        const nodes = [];
        for (let a of left.result.percent) {
            const item = right.result.percent.find(b=>a.key === b.key);
            let node = undefined;
            if (item === undefined) {
                node = <Row style={{color: 'red'}}>
                    <Col span={8}><span>+ {a.key}</span></Col>
                    <Col span={1}>|</Col>
                    <Col span={7}><span>{a.value.toFixed(2)}%</span></Col>
                    <Col span={1}>|</Col>
                    <Col span={7}></Col>
                </Row>
            } else if (a.value > item.value) {
                node = <Row style={{color: '#faad14'}}>
                    <Col span={8}><span>{'>'} {a.key}</span></Col>
                    <Col span={1}>|</Col>
                    <Col span={7}><span>{a.value.toFixed(2)}%</span></Col>
                    <Col span={1}>|</Col>
                    <Col span={7}><span>{item.value.toFixed(2)}%</span></Col>
                </Row>
            } else if (a.value < item.value) {
                node = <Row style={{color: '#1890ff'}}>
                    <Col span={8}><span>{'<'} {a.key}</span></Col>
                    <Col span={1}>|</Col>
                    <Col span={7}><span>{a.value.toFixed(2)}%</span></Col>
                    <Col span={1}>|</Col>
                    <Col span={7}><span>{item.value.toFixed(2)}%</span></Col>
                </Row>
            } else {
                node = <Row style={{color: 'gray'}}>
                    <Col span={8}><span>= {a.key}</span></Col>
                    <Col span={1}>|</Col>
                    <Col span={7}><span>{a.value.toFixed(2)}%</span></Col>
                    <Col span={1}>|</Col>
                    <Col span={7}><span>{item.value.toFixed(2)}%</span></Col>
                </Row>
            }
            nodes.push(node);
        }

        for (let b of right.result.percent) {
            const item = left.result.percent.find(a=>a.key === b.key);
            if (item === undefined) {
                const node = <Row style={{color: 'green'}}>
                    <Col span={8}><span>- {b.key}</span></Col>
                    <Col span={1}>|</Col>
                    <Col span={7}></Col>
                    <Col span={1}>|</Col>
                    <Col span={7}><span>{b.value.toFixed(2)}%</span></Col>
                </Row>
                nodes.push(node);
            }
        }

        return <div style={{width: 500}}>
            {nodes}
        </div>;
    }

    getTagFullName(tagId) {
        for (let category of this.state.tagsOptions) {
            for (let tag of category.children) {
                if (tag.value === tagId.toString()) {
                    return `${category.label} / ${tag.label}`
                }
            }
        }
        return ''
    }

    getClusterPercent(side) {
        return ((side.todayResult / side.todayTotal) * 100).toFixed(2);
    }

    async fetchLeftCharts() {
        const preparedCharts = await UIFetchService.get(`/api/v1/user_clustering/clusters/${this.props.leftId}/charts`);
        const charts = preparedCharts.map(chart=>{
            chart.loading = true;
            return chart;
        });
        for (let chart of charts) {
            UIFetchService.get(`/api/v1/user_clustering/clusters/${this.props.leftId}/charts/${chart.id}`)
                .then((result) => {
                    const charts = this.state.charts;
                    chart.result = result;
                    chart.loading = false;
                    this.setState({ charts });
                });
        }
        //this.setState({ leftCharts: charts });
        return charts;
    }

    fetchRightCharts(charts) {
        for (let chart of charts) {
            UIFetchService.get(`/api/v1/user_clustering/clusters/${this.props.leftId}/vs/${this.props.rightId}/charts/${chart.id}`)
                .then((result) => {
                    const charts = this.state.charts;
                    chart.result = result;
                    chart.loading = false;
                    this.setState({ charts });
                });
        }
    }
}

export default UserClusteringAnalysisComparator;